<template>
  <div>
    <p>没有访问权限</p>
  </div>
</template>

<script>

export default {
  data () {
    return {
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/403.vue